import { useLang } from "@/contexts/LanguageContext";
import { t } from "@/translations";
import { studentAchievements } from "@/mocks/speakers";

export default function StudentAchievements() {
  const { lang } = useLang();
  const tr = t[lang].studentAchievements;
  const isEn = lang === "en";

  return (
    <section className="w-full py-16 bg-[#fafafa]">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-10 leading-snug">
          {tr.heading}
        </h2>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-6">
          {studentAchievements.map((item) => (
            <div key={item.id} className="flex flex-col items-center gap-3 text-center">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden border-2 border-[#c8e6c9] flex-shrink-0">
                <img
                  src={item.image}
                  alt={isEn ? item.labelEn : item.label}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <p className="text-xs md:text-sm text-gray-700 font-medium leading-tight">
                {isEn ? item.labelEn : item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
